import PT from 'prop-types';
import s from './styles.scss';
import { FilterLabels } from 'edrolo/domains/exams/components';
import { Icon, enums } from 'edrolo-ui';
import { ENABLED_WORKING_PATHWAYS_FILTER_COURSE_IDS } from '../../constants';
import cx from 'classnames';
import { Link } from 'react-router-dom';

export const QuestionSetNavBar = ({
  previousQuestionUrl,
  nextQuestionUrl,
  questionSetIndexUrl,
  searchParams,
  courseId,
  isEmInsights,
}) => {
  const enableFilterFeatures =
    global.waffle.flag_is_active('enable_working_pathway_filter') ||
    ENABLED_WORKING_PATHWAYS_FILTER_COURSE_IDS.includes(courseId);

  const title = isEmInsights ? 'insights' : 'questions';

  return (
    <div
      className={cx(s.questionSetNavBar, {
        [s.noLabels]: !enableFilterFeatures,
      })}
    >
      <div>
        <Link
          to={previousQuestionUrl}
          className={s.link}
          disabled={!previousQuestionUrl}
          data-test="previous-question-navbar-link"
        >
          <Icon name={enums.Icons.CHEVRON_LEFT} />
          &nbsp;Previous question
        </Link>
        <Link
          to={questionSetIndexUrl}
          className={s.link}
          data-test="all-questions-navbar-link"
        >
          All {title}
        </Link>
        <Link
          to={nextQuestionUrl}
          className={s.link}
          disabled={!nextQuestionUrl}
          data-test="next-question-navbar-link"
        >
          Next question &nbsp;
          <Icon name={enums.Icons.CHEVRON_RIGHT} />
        </Link>
      </div>

      {enableFilterFeatures && (
        <FilterLabels
          searchParams={searchParams}
          changeSelectionUrl={questionSetIndexUrl}
        />
      )}
    </div>
  );
};

QuestionSetNavBar.propTypes = {
  previousQuestionUrl: PT.string,
  nextQuestionUrl: PT.string,
  questionSetIndexUrl: PT.string.isRequired,
  searchParams: PT.object.isRequired,
  courseId: PT.number.isRequired,
  isEmInsights: PT.bool,
};
